export default angular.module("MessageService", []).factory("Message", [
  "$http",
  "$rootScope",
  "$filter",
  "Flash",
  function ($http, $rootScope, $filter, Flash) {
    const loading = { messages: false };

    // Load count of unread messages from the database
    function loadCountUnreadMessages(callback) {
      $http
        .get("/api/system_messages/countunread")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load sent messages by user id from the database
    function loadMessagesFromUser(callback) {
      loading.messages = true;
      $http
        .get("/api/system_messages/from")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load received messages to user id from the database
    function loadMessagesToUser(callback) {
      loading.messages = true;
      $http
        .get("/api/system_messages/to")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load received messages linked to alias from the database
    function loadMessagesLinkedToAlias(aliasId, callback) {
      loading.messages = true;

      $http
        .get(`/api/system_messages/alias/${aliasId}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load received messages linked to script from the database
    function loadMessagesLinkedToScript(scriptid, callback) {
      loading.messages = true;
      $http
        .get(`/api/system_messages/script/${scriptid}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load received messages with ID from the database
    function loadMessageWithID(messageid, callback) {
      loading.messages = true;
      $http
        .get(`/api/system_messages/withid/${messageid}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load child message(s) for message with id from the database
    function loadMessageChild(messageid, callback) {
      loading.messages = true;
      $http
        .get(`/api/system_messages/child/${messageid}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load parent message for message with id from the database
    function loadMessageParent(messageid, callback) {
      loading.messages = true;
      $http
        .get(`/api/system_messages/parent/${messageid}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    // Load all receivers for message with id from the database
    function loadMessageReceiver(messageid, callback) {
      loading.messages = true;
      $http
        .get(`/api/system_messages/receivers/${messageid}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.messages = false;
        });
    }

    const createMessageItem = (messageItem, callback) => {
      $http
        .post("/api/system_messages", messageItem)
        .success((data, status) => callback(data, status))
        .error((data, status) => {
          const errorMessage = `Creating a new message item failed with error code: ${status}`;
          Flash.create("danger", errorMessage, "basicAlert");
          callback(data, status);
        });
    };

    function updateMessage(inboxMessage, callback) {
      $http.put(`/api/system_messages/${inboxMessage.ID}`, inboxMessage).then(
        (res) => {
          const message = "Message updated";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Saving message failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteMessage(inboxMessage, callback) {
      $http.delete(`/api/system_messages/${inboxMessage.ID}`, inboxMessage).then(
        (res) => {
          const message = "Message deleted";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Deleting message failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function updateAssigned(receiver, callback) {
      $http.put("/api/system_messages/actions/update_assigned", receiver).then(
        (res) => {
          const message = "'Assigned to' updated";
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Saving message assigned to failed with error code: ${
            res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    return {
      loading,
      loadCountUnreadMessages,
      loadMessagesFromUser,
      loadMessagesToUser,
      loadMessagesLinkedToAlias,
      loadMessagesLinkedToScript,
      loadMessageWithID,
      loadMessageChild,
      loadMessageParent,
      loadMessageReceiver,
      createMessageItem,
      updateMessage,
      deleteMessage,
      updateAssigned,
    };
  },
]);
